import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { FacebookActivePagesTable as View } from './FacebookActivePagesTable'

export const FacebookActivePagesTable = withStyles(styles)(View)
